<div class="title" mat-dialog-title>
    <span class="title-content">Please explain why you need to edit the account</span>
</div>

<mat-dialog-content class="edit-reason-content">
    <textarea
            matInput
            [(ngModel)]="reason"
            placeholder="Enter your reason here..."
            rows="4"
            class="reason-textarea">
    </textarea>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="cancelDialog()">Cancel</button>
    <button mat-button color="primary" (click)="submit()" [disabled]="!reason.trim()">Submit</button>
</mat-dialog-actions>
